import React from 'react';

const ErrorIcon = () => {
  return (
    <svg className='iconTop' width='120' height='120' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.92 97.37a1.25 1.25 0 0 0 2.16 1.262l-2.16-1.261zm80 1.263a1.25 1.25 0 0 0 2.159-1.261l-2.158 1.26zM85.316 60.078a1.25 1.25 0 0 0-2.285-1.016l2.285 1.016zm-21.833-35.59a1.25 1.25 0 0 0 .34-2.476l-.34 2.476zM21.08 98.632C29.107 84.896 43.94 76.428 60 76.428v-2.5c-16.939 0-32.599 8.931-41.08 23.443l2.16 1.261zM60 76.428c16.06 0 30.894 8.469 38.92 22.205l2.159-1.261C92.599 82.86 76.939 73.928 60 73.928v2.5zm23.03-17.366c-5.218 11.74-18.636 17.633-30.963 13.567l-.783 2.374c13.53 4.463 28.284-1.995 34.03-14.925l-2.284-1.016zM52.067 72.63c-12.322-4.064-19.465-16.73-16.51-29.207l-2.433-.576c-3.259 13.76 4.625 27.693 18.16 32.157l.783-2.374zm-16.51-29.207C38.513 30.94 50.61 22.721 63.482 24.49l.34-2.477c-14.126-1.94-27.44 7.078-30.698 20.834l2.433.576z'
        fill='#000'
      />
      <path
        clipRule='evenodd'
        d='M78.79 47.877h-7.161c-.66 0-1.194-.534-1.194-1.193v-6.666c0-.317.126-.62.35-.844l17.9-17.9a1.193 1.193 0 0 1 1.688 0l6.666 6.666a1.193 1.193 0 0 1 0 1.687l-18.25 18.25z'
        stroke='var(--theme-primary, #810ea9)'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='m83.943 26.016 8.354 8.354' stroke='var(--theme-primary, #810ea9)' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default ErrorIcon;
